import type * as Types from '../../types';

import client from "apollo/client";
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCertificateChainInfoQueryVariables = Types.Exact<{
  certificateId: Types.Scalars['UUID'];
}>;


export type GetCertificateChainInfoQuery = { __typename?: 'Query', certificateChainInfo: Array<{ __typename?: 'CertificateChainInfo', certificateId: string, certificateCode: string, certificateNumber: string, chainLevel: number, currentValidityStatus: string }> };


        export type ExecGetCertificateChainInfoOptions = Omit<
        Apollo.QueryOptions<
        GetCertificateChainInfoQueryVariables, GetCertificateChainInfoQuery
        >,
        "query"
      >;
    export const execGetCertificateChainInfoQuery = (options: ExecGetCertificateChainInfoOptions) =>
    client.query< GetCertificateChainInfoQuery, GetCertificateChainInfoQueryVariables>({
      ...options,
      query: GetCertificateChainInfoDocument,
    });
    

export const GetCertificateChainInfoDocument = gql`
    query getCertificateChainInfo($certificateId: UUID!) {
  certificateChainInfo(certificateId: $certificateId) {
    certificateId
    certificateCode
    certificateNumber
    chainLevel
    currentValidityStatus
  }
}
    `;

/**
 * __useGetCertificateChainInfoQuery__
 *
 * To run a query within a React component, call `useGetCertificateChainInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCertificateChainInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCertificateChainInfoQuery({
 *   variables: {
 *      certificateId: // value for 'certificateId'
 *   },
 * });
 */
export function useGetCertificateChainInfoQuery(baseOptions: Apollo.QueryHookOptions<GetCertificateChainInfoQuery, GetCertificateChainInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCertificateChainInfoQuery, GetCertificateChainInfoQueryVariables>(GetCertificateChainInfoDocument, options);
      }
export function useGetCertificateChainInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCertificateChainInfoQuery, GetCertificateChainInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCertificateChainInfoQuery, GetCertificateChainInfoQueryVariables>(GetCertificateChainInfoDocument, options);
        }
export type GetCertificateChainInfoQueryHookResult = ReturnType<typeof useGetCertificateChainInfoQuery>;
export type GetCertificateChainInfoLazyQueryHookResult = ReturnType<typeof useGetCertificateChainInfoLazyQuery>;
export type GetCertificateChainInfoQueryResult = Apollo.QueryResult<GetCertificateChainInfoQuery, GetCertificateChainInfoQueryVariables>;
export type PartialResultType<T> = Types.PartialResultType<T>;
          export type ResultType<T> = Types.ResultType<T>;
          export type PaginatedResultType<T> = Types.PaginatedResultType<T>;
          export type NonMaybe<T> = Types.NonMaybe<T>;
          export type Maybe<T> = Types.Maybe<T>;